import axios from "../../../../axios";

// Base API configuration
const API_BASE = process.env.REACT_APP_AI_DIAGNOSTIC_URL;

// Helper function to get auth headers
const getAuthHeaders = () => {
  // Use the Claude server token for AI diagnostic APIs
  const token = localStorage.getItem('claudeToken');
  if (!token) {
    throw new Error('Claude server token not found. Please login to the Claude server first.');
  }
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

// Conversation History API
export const conversationHistoryApi = {
  // Get paginated conversations
  getConversations: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/api/conversations`, {
      headers: getAuthHeaders(),
      params: {
        page: params.page || 1,
        limit: params.limit || 20,
        startDate: params.startDate || "",
        endDate: params.endDate || "",
        slackUserId: params.slackUserId || "",
        ...params,
      },
    });
    return response.data;
  },

  // Get conversation details with messages
  getConversationDetail: async (conversationId, params = {}) => {
    const response = await axios.get(`${API_BASE}/api/conversations/${conversationId}`, {
      headers: getAuthHeaders(),
      params: {
        page: params.page || 1,
        limit: params.limit || 50,
        ...params,
      },
    });
    return response.data;
  },
};

// System Prompts (Projects) API
export const systemPromptsApi = {
  // Get all projects
  getProjects: async () => {
    const response = await axios.get(`${API_BASE}/api/projects`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  // Get project by ID
  getProjectById: async (projectId) => {
    const response = await axios.get(`${API_BASE}/api/projects/${projectId}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  // Create new project
  createProject: async (projectData) => {
    const response = await axios.post(`${API_BASE}/api/projects`, projectData, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  // Update project
  updateProject: async (projectId, projectData) => {
    const response = await axios.put(`${API_BASE}/api/projects/${projectId}`, projectData, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  // Publish project
  publishProject: async (projectId) => {
    const response = await axios.post(`${API_BASE}/api/projects/${projectId}/publish`, {}, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  // Unpublish project
  unpublishProject: async (projectId) => {
    const response = await axios.post(`${API_BASE}/api/projects/${projectId}/unpublish`, {}, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  // Get project versions
  getProjectVersions: async (projectId) => {
    const response = await axios.get(`${API_BASE}/api/projects/${projectId}/versions`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  // Revert project to version
  revertProjectToVersion: async (projectId, version) => {
    const response = await axios.post(`${API_BASE}/api/projects/${projectId}/revert/${version}`, {}, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
};
